import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import type { User } from 'oidc-client-ts';
import { upsertXimiAccount } from './storage/ximiAccounts';
import { deriveXimiAccountFromSsoProfile } from './ximiSsoProfile';

async function persistAccount(user: User): Promise<void> {
    const account = deriveXimiAccountFromSsoProfile(user.profile);
    if (!account) return;
    await upsertXimiAccount(account);
}

/**
 * Cross-platform: records the authenticated identity as the current Ximi account
 * (derived from SSO claims) whenever react-oidc-context reports a user. The SSO
 * tokens themselves are persisted by oidc-client-ts — read them via ximiSso.
 */
export function usePersistXimiAccount(): void {
    const auth = useAuth();

    useEffect(() => {
        if (!auth.isAuthenticated || !auth.user) return;
        persistAccount(auth.user);
    }, [auth.isAuthenticated, auth.user]);
}
